module.exports = __webpack_public_path__ + "img/baroque.a6665dcb.jpg";